export default __webpack_public_path__ + "static/media/card-03.79c5c723.svg";